import { TEditCredentialsAction, EditCredentialsActionTypes } from './editCredentialsActions';
import { IEditCredentialsState } from './editCredentialsContext';

export const editCredentialsReducer = (
	state: IEditCredentialsState,
	action: TEditCredentialsAction,
): IEditCredentialsState => {
	switch (action.type) {
		case EditCredentialsActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditCredentialsActionTypes.SET_ALL_DATA:
			return {
				...state,
				credentialID: action.payload.credentialID,
				credentialType: action.payload.credentialType,
				credentialName: action.payload.credentialName,
				apiKey: action.payload.apiKey,
				apiSecret: action.payload.apiSecret,
			};
		case EditCredentialsActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditCredentialsActionTypes.CHANGE_CREDENTIAL_NAME:
			return {
				...state,
				credentialName: action.payload.credentialName,
			};
		case EditCredentialsActionTypes.CHANGE_API_KEY:
			return {
				...state,
				apiKey: action.payload.apiKey,
			};
		case EditCredentialsActionTypes.CHANGE_API_SECRET:
			return {
				...state,
				apiSecret: action.payload.apiSecret,
			};
		case EditCredentialsActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditCredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditCredentialsActionTypes.RESET_FIELDS:
			return {
				...state,
				credentialID: '',
				credentialType: null,
				credentialName: '',
				apiKey: '',
				apiSecret: '',
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
